import { InfoModalSignUpResSchema } from "@/models/infoModalRes.dto";
import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { SignUpFormSchema } from "../models";

export abstract class SignUpFormApi {
  static async send(params: SignUpFormSchema) {
    const query = {
      ...params,
      requestType: "user",
    };

    return withSchemaValidation(
      GbApiRequestService.post("userApi", query, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }),
      InfoModalSignUpResSchema,
    );
  }
}
